import { render, staticRenderFns } from "./DriversFormVehicleDrawer.vue?vue&type=template&id=5c8ee982&scoped=true&"
import script from "./DriversFormVehicleDrawer.vue?vue&type=script&lang=js&"
export * from "./DriversFormVehicleDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DriversFormVehicleDrawer.vue?vue&type=style&index=0&id=5c8ee982&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c8ee982",
  null
  
)

export default component.exports